//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import * as axios from "@/store/http"
import FfBreadcb from "@/pccomponents/FfBreadcb"
import treetag from "@/pccomponents/TreeTag";
import formValidate from "@/js/formValidate";
  export default {
    name: "DeptOrganize",
    components: {
      FfBreadcb,
      treetag
    },
    data(){
      return {
        formval:{},
        areacode:'',
        showtree:false,
        rules: [],
        dialogDetailVisible:false,
        queryinfo: {
          vdeptid:"",
          vdeptname: "",
          vareacode:""
        },
        //左侧树列表
        treedata:[],
        //右侧表单列表
        tableData:[],
        record:{},
        defaultProps: {
          children: 'children',
          label: 'deptname'
        },
        yesornolist:[
        ],
        //部门类型
        depttypelist:[],
        currPage: 1,
        rowsPerPage: 5,
        totalPage: 1,
        //控制编辑项
        edititems:"",
        //规则校验信息
        formTipArray:[],
        //是否显示文本域
        showDialog:false,
        deldept:[],
        flowsysid:'FLOW',
      }
    },
    methods: {
      deleteDept(){
        let deldeptids = [];
        for(let dept of this.deldept){
          deldeptids.push(dept.id);
        }

        let params = {
          deptids:deldeptids
        }
        if(deldeptids.length <=0){
            this.tipWarn(this.$t('common.delnoselected'));
        }else{
          let url = "deptController/deleteDept";
          if(confirm(this.$t('organize.deleteConfig'))==true){
            //请求后端数据
            axios.post(url, params).then(({ data }) => {
              this.queryList();
              //  this.$refs.myTreechild.init();
            });
          }
        }
      },
      selectCheck(val){
        this.deldept =val;
      },
     /**
      * 分页记录
      */
      pageChange (item) {
        this.currPage = item.page_index;
        this.rowsPerPage = item.page_limit;
        this.queryList() //改变页码，重新渲染页面
      },
      /**
       * 查询右侧列表记录
       */
      queryList(){
        let url = "deptController/deptlist";
        let params = {
          queryinfo:{
            vdeptid :this.queryinfo.vdeptid,
            vdeptname :this.queryinfo.vdeptname
          },
          pageinfo:{
              currPage: this.currPage,
              rowsPerPage: this.rowsPerPage
          },
          flowsysid:this.flowsysid
        }
        //请求后端数据
        axios.post(url, params).then(({ data }) => {
           this.tableData = data.data.record;
           this.totalPage = data.data.pageinfo.count;
           this.queryinfo.vareacode = data.data.areacode;
        });
      },
      // 点击树节点
      clickTree(data) {
         window.sessionStorage.setItem("loginedStatus", false); 
        console.log(data);
        this.queryinfo.vdeptid = data.id;
        //if(this.queryinfo.vdeptid != '0'){
          //设置地区ID
          this.queryinfo.vareacode = data.areacode;
          this.queryinfo.vdeptname = "";
          this.queryList();
        //}
      },
      //改变每页显示的记录数
      handleSizeChange(val) {
        this.rowsPerPage = val;
        this.queryList();
      },
      /**
       * 打开新增部门列表
       */
      addDept(){
        this.showDialog = true;
        this.dialogDetailVisible = true;
        let url = "deptController/deptloadadd";
        let params = {
          record:{
            pdeptid:this.queryinfo.vdeptid,
            areacode :this.queryinfo.vareacode
          },
          flowsysid:this.flowsysid
        }
        //请求后端数据
        axios.post(url, params).then(({ data }) => {
           if(data.code === '1'){
            this.record = data.data.record.record;
            //加载必填域
            formValidate.initViewInfo4NotFlow(this,data.data.formValidateInfo);
            console.log('2020年01月02日09:35:16 deptorganize.vue[描述]——[data.data.edititems] :',data.data.edititems);
            this.edititems = data.data.edititems;
           }else{
                this.tipSuccess('系统发生异常');
           }
        });
        this.initSelect();
      },
      /**
       * 保存部门
       */
      savedept(){
        let url = "deptController/savedept";
        let params = {
          record : this.record,
          flowsysid:this.flowsysid
        }
        this.$refs["deptform"].validate((valid) => {
          // 验证通过
          if (valid) {
              //请求后端数据
            axios.post(url, params).then(({ data }) => {
              console.log("======="+data);
            //单据获取成功
            if(data.code === '1'){
              this.tipSuccess(this.$t("common.savesuccess"));
              this.queryList();
              this.dialogDetailVisible =false;
            }

            });
          } else {
            // 验证不通过
            this.formErrorTip("信息错误",this.formTipArray)
            this.formTipArray.length=0
            return false;
          }
        });
       // this.$refs.myTreechild.init();
      },
      
      /**
       * 取消按钮事件
       */
      changle(){
        this.dialogDetailVisible =false;
        this.showDialog = false;
        this.edititems ="";
        this.closeDialog();
      },

      /**
       * 关闭弹出框清空数据
       */
      closeDialog(){
        this.showDialog = false;
        this.edititems ="";
        this.record = [];
      },
      /**
       * 查看现有部门详细记录
       */
      modifityDept(index, row){
         // this.tipSuccess(row.deptid);
        this.dialogDetailVisible = true;
        this.showDialog = true;
        let url = "deptController/deptload";
        let params = {
            deptid:row.id,
            areacode :this.queryinfo.vareacode,
            flowsysid:this.flowsysid,
        }
        //请求后端数据
        axios.post(url, params).then(({ data }) => {
           console.log(data);
           this.record = data.data.record;
           //加载必填域
           formValidate.initViewInfo4NotFlow(this,data.data.formValidateInfo);
           this.edititems = data.data.edititems;
        });
        this.initSelect();
     },
     /**
       * 初始化全部下拉框
       */
      initSelect(){
         //初始化下拉框
        let yesnoparam = {
          showcode:'yesornolist',
          selectcode:'SYS_CDFCODECONFIG',
          hasnull:true,
          paras:{"paras0":"YESORNO","paras1":"1"}
        };
        let depttypeparam= {
          showcode:'depttypelist',
          selectcode:'SYS_CDFCODECONFIG',
          hasnull:true,
          paras:{"paras0":"DEPTTYPE","paras1":"1"}
        };

        let params = [];
        params.push(yesnoparam);
        params.push(depttypeparam);

        this.initDropDown(this,params);
      },
      inituser(){
      let url = "userController/getUserInfo";
      let params = {
  
      }
      //请求后端数据
      axios.post(url, params).then(({ data }) => {
          this.areacode = data.data.position.areacode;
          this.showtree = true;
        
      });
    },
    openModel() {
          this.setDialogPos();
      }
    },
    created(){
      this.inituser();
    },
      mounted() {
          this.setMainContentHeight();
      }
  }



// WEBPACK FOOTER //
// ./src/pcpage/system/organize/deptorganize.vue